import {
  Stack,
  FormControl,
  FormControlProps,
} from "@chakra-ui/react";
import { HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";
import { longAttributeStyles } from "components/DataDisplay/styles";
import { UseFormReturn, Controller } from "react-hook-form";
import { MeetingAttendee } from "features/Resources/Meeting/models";
import { get } from "lodash";
import ErrorText from "components/FormElements/ErrorText";
import UserRoleOrEmailMultiSelect, { UserRoleOrEmailOption } from "components/FormElements/Fields/SelectFields/UserRoleOrEmailMultiSelect";
import { useCallback, useMemo } from "react";
import { fromUserRoleOrEmailOption, toUserRoleOrEmailOption } from "features/Resources/Meeting/helpers";

function SelectWrapper({
  value,
  onChange,
}: {
  value: MeetingAttendee[],
  onChange: (value: Partial<MeetingAttendee>[]) => void;
}) {
  const selectValue = useMemo(() => (value || []).map((formAttendee) => toUserRoleOrEmailOption(formAttendee)), [value]);
  const updateFormAttendees = useCallback((selectedAttendees: UserRoleOrEmailOption[]) => {
    onChange((selectedAttendees || []).map((selectedAttendee) => fromUserRoleOrEmailOption(selectedAttendee)));
  }, [onChange]);

  return (
    <UserRoleOrEmailMultiSelect
      value={selectValue}
      onChange={(selected) => updateFormAttendees(selected)}
      includeRole={false}
      includePersonal
    />
  );
}

interface MeetingAttendeesFieldProps {
  form: UseFormReturn<any>;
  label: string;
  fieldName: string;
  disabled?: boolean;
  includeErrors?: boolean;
  formControlProps?: FormControlProps;
}

export default function MeetingAttendeesField({
  form,
  label,
  fieldName,
  disabled = false,
  includeErrors = false,
  formControlProps = {},
}: MeetingAttendeesFieldProps) {
  const {
    control,
    formState: { errors },
  } = form;

  const error = includeErrors ? get(errors, fieldName) : undefined;

  return (
    <HorizontalGreyBlackField
      label={label}
      labelContainerProps={longAttributeStyles.labelContainerProps}
    >
      <FormControl
        variant="unstyled"
        id={fieldName}
        isInvalid={!!error}
        isDisabled={disabled}
        {...formControlProps}
      >
        <Stack>
          <Controller
            control={control}
            name={fieldName}
            render={({ field: { onChange, value, ref } }) => (
              <SelectWrapper value={value} onChange={onChange} />
            )}
          />
          <ErrorText error={error} />
        </Stack>
      </FormControl>
    </HorizontalGreyBlackField>
  );
}
